import React from 'react';

const Drone = () => {
  
  const droneImage = process.env.PUBLIC_URL + '/images/drone.jpg';

  // second dynamic image
  const secondImage = process.env.PUBLIC_URL + '/images/img-7-Photoroom.png';

  return (
    <section className='drone-section'>
        <div className='container'>
            <div className='inner-content'>
                <div className='left-wrap'>
                    <div className='img-box'>
                    <img src='' alt='Drone Inspection' style={{display: 'none'}}></img>

                    {/* Professional Image */}
                    <img 
                        src={droneImage} 
                        alt="Drone Roof Inspection"
                        className="drone-image"
                    />

                    {/* Caption */}
                    <p className="drone-caption">
                        We use drone to inspect the roof.
                    </p>

                </div>
                </div>
                <div className='right-wrap'>
                    <div className='img-box-002'>
                    
                        <img 
                            src={secondImage} 
                            alt="Drone Inspection View"
                            className="drone-image-002"
                        />

                    </div>
                </div>  
            </div>
        </div>
    </section>
  );
};

export default Drone;